import { Stack } from '@mui/material';
import ProductBreakdown from 'src/features/CompanyDetail/HSCode/ProductBreakdown';
import Top10HSCode from 'src/features/CompanyDetail/HSCode/Top10HSCode';

const HSCode = ({ company }: { company?: ICompanyDetail }) => {
  return (
    <Stack spacing={3}>
      <ProductBreakdown />
    </Stack>
  );
};

export default HSCode;
